export function componentInitWktab(payload) {
  return {
    type: 'COMPONENT_INIT_WKTAB',
    payload,
  }
}

export function componentSelectTab(id) {
  return {
    type: 'COMPONENT_SELECT_TAB',
    payload: id,
  }
}

export function componentInitWktabPlus(payload) {
  return dispatch => {
    dispatch(componentInitWktab({ list: payload.list }))
    dispatch(componentSelectTab(payload.selectId))
  }
}


// WEBPACK FOOTER //
// ./src/actions/component.js